/* @flow */

import * as React from 'react';
import styled from 'styled-components';

import zIndexScale from '../utils/zIndexScale';
import Spinner from './Spinner';

const Shade = styled.div`
  background-color: ${({ theme }) => theme.loadingShadeColor};
  bottom: 0;
  right: 0;
  height: 100%;
  left: 0;
  pointer-events: none;
  position: absolute;
  top: 0;
  opacity: 0;

  width: 100%;
  z-index: ${zIndexScale.loading};
  display: none;

  ${({ hidden }) => !hidden ? `
    display: block;
    pointer-events: auto;
    opacity: 1;
  ` : ''}
`;

export type Props = {
  hidden: boolean,
};

export default (props: Props) => (
  <Shade {...props}>
    <Spinner />
  </Shade>
);
